export default {
    title: "The Wellness League search tool",
    description: "If you are in need of local services just enter your zip code for a list of community services in your area",
};